import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { RouteScriptRunner } from '@kizenapps/engine/react';
import { PluginContext } from 'ts-components/Plugins/context';

export const RouteScriptHandler = () => {
  const { routeScripts, sessionInvalid } = useContext(PluginContext);
  const { pathname } = useLocation();

  if (!routeScripts.length || sessionInvalid) {
    return null;
  }

  return <RouteScriptRunner pathname={pathname} routeScripts={routeScripts} />;
};
